package com.devi3east.bashbuddy.features.events.common.data.models

import kotlinx.serialization.Serializable

@Serializable
enum class RaffleType {
    SIDE_RAFFLE,
    MAIN_RAFFLE
}